import { Pagination } from "services/search";

import {
  Tire,
  TireEditFormValues,
  TireManufacturerRow,
  TireRow,
} from "./types";
import {
  transformTire,
  transformTireManufacturerRow,
  transformTireOnCreate,
  transformTireOnUpdate,
  transformTireRow,
} from "./transformations";
import { DataWithPagination } from "services/api/types";
import { createApiCall, paginatedApiCall } from "services/api/createApiCall";
import { transformErrorResponse } from "services/api/transformation";

/*---------------------------------------------------------------------------------------
  TIRE SEARCH
-----------------------------------------------------------------------------------------*/

export const getTiresAPI = async (
  pagination: Pagination,
  name?: string | null
): Promise<DataWithPagination<TireRow>> => {
  let path = `/v1/expenses/tires?name=`;

  if (name) path += `${name}`;

  return await paginatedApiCall(path, pagination, transformTireRow);
};

/*---------------------------------------------------------------------------------------
     TIRE - BY ID
-----------------------------------------------------------------------------------------*/
export const getTireAPI = async (id: string): Promise<Tire> => {
  const response = await createApiCall(
    {
      path: `/v1/expenses/tires/${id}`,
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformTire(response.data);
};

/*---------------------------------------------------------------------------------------
     TIRE - CREATE
-----------------------------------------------------------------------------------------*/
export const createTireAPI = async (
  formValues: TireEditFormValues
): Promise<Tire> => {
  const response = await createApiCall(
    {
      path: "/v1/expenses/tires/",
      method: "POST",
      body: transformTireOnCreate(formValues),
    },
    {
      getMessage: {
        success: () => "Guma je uspješno kreiran",
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformTire(response.data);
};

/*---------------------------------------------------------------------------------------
     TIRE - UPDATE
-----------------------------------------------------------------------------------------*/
export const updateTireAPI = async (
  id: string,
  formValues: TireEditFormValues
): Promise<Tire> => {
  const response = await createApiCall(
    {
      path: `/v1/expenses/tires/${id}`,
      method: "PUT",
      body: transformTireOnUpdate(formValues),
    },
    {
      getMessage: {
        success: () => "Guma je uspješno ažurirana",
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformTire(response.data);
};

/*---------------------------------------------------------------------------------------
     - TIRE - DELETE
-----------------------------------------------------------------------------------------*/
export const deleteTireAPI = async (id: string): Promise<boolean> => {
  const response = await createApiCall(
    {
      path: `/v1/expenses/tires/${id}`,
      method: "DELETE",
    },
    {
      getMessage: {
        success: () => "Gume je uspješno obrisana",
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return response.data;
};

/*---------------------------------------------------------------------------------------
  TIRE MANUFACTURER SEARCH
-----------------------------------------------------------------------------------------*/

export const getTireManufacturersAPI = async (
  pagination: Pagination,
  name?: string | null
): Promise<DataWithPagination<TireManufacturerRow>> => {
  let path = `/v1/catalog/tires/manufacturers?name=`;

  if (name) path += `${name}`;

  return await paginatedApiCall(path, pagination, transformTireManufacturerRow);
};
